import { DISPLAY_LOCALE, MAX_MESSAGES } from "../config";

export type MessageType = "SUCCESS" | "WARN" | "ERROR" | "INFO";

export function renderMessage(
  params: { message?: string; type?: MessageType },
): HTMLElement | null {
  const container = document.getElementById("messages");
  if (!container) {
    console.warn('[renderMessage] Missing #messages container');
    return null;
  }

  const time = new Intl.DateTimeFormat(DISPLAY_LOCALE, {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // browser tz
    dateStyle: "short",
    timeStyle: "medium",
  }).format(new Date());

  const message = params.message ?? "empty";
  const type = params.type ?? "INFO";

  const elem = document.createElement("div");
  elem.classList.add("messageBox");
  elem.innerHTML = `
    <div>${time}</div>
    <div>${message}</div>
  `;

  // keep your inline color logic
  switch (type) {
    case "SUCCESS":
      elem.setAttribute("style", "background-color:#e2ffe2;");
      break;
    case "WARN":
      elem.setAttribute("style", "background-color:#fffbd9;");
      break;
    case "ERROR":
      elem.setAttribute("style", "background-color:#ffc0c0;");
      break;
    // INFO → default styles
  }

  container.prepend(elem);

  while (container.childElementCount > MAX_MESSAGES) {
    container.removeChild(container.lastChild as ChildNode);
  }

  return elem;
}

export function clearMessages(): void {
  const container = document.getElementById("messages");
  if (container) container.textContent = "";
}
